<template lang='pug'>
  blue-layout( v-if='business.status && business.status.title == "Unavailable" && biz.id != business.id' :user='user' :account='account' :biz='biz')
    bf-wrapper.max.unavailable
      img(:src='business.logo' width='200')
      h1 {{ business.name }}
      p
        h3 {{ $t( "is undergoing maintenance and is currently unavailable" ) }}
      p
        img(src='/ui/under-construction.svg' width='500')
      
  blue-layout( 
    v-else :user='user' 
    :account='account' 
    :biz='biz' 
    :style='style'
  )
    template( v-slot:default='props' )
      bf-flex.stamp.component.centered( v-if='business.sample' ) 
        label {{$t("SAMPLE")}}

      bf-notice( @close='message = ""' :message='message' )
      base-modal#cpn-dtls( :show='!!coupon' )
        cpn-dtls( 
          :item='coupon'
          :biz='merchant'
          :account='account'
          :user='user'
          @close='coupon = false'
        )

      bf-dialog#reserve-dialog(
        :show='show.reserve'
        :scrolled='props.scrolled'
        @close='show.reserve = false'
      )
        reserve-dialog(
          v-if='business'
          :business='business'
          :account='account'
          :user='user'
          :biz='biz'
          :service_id='service_id'
          :settings='settings'
          :msg='msg'
          @close='show.reserve = false'
          @notify='notify'
        )

      base-modal#srv-dtls-dialog(
        :show='!!srv'
      )
        modal-wrapper.max-800( @close='srv = false' )
          template( v-slot:header )
            h3 {{ $t('Service Details') }}

          template( v-slot:contents )
            srv-dtls(
              :biz='business'
              :srv='srv'
              :collection='collection'
            )
            
          template( v-slot:footer )
            .msg
              h5( v-if='srv.instructions' ) {{ srv.instructions }}
              h5( v-else) {{ $t("Message to merchant")}}:
    
              bf-input
                input( type='text' v-model='msg')

              .rsv-btn( v-if='account.id != business.user_id' )
                bf-button.bright.wide.bold( v-if='blacked' )
                  template( v-slot:text ) {{ $t('Not Available') }}

                bf-button.bright.wide.bold( v-else @click.native='reserve' )
                  template( v-slot:text ) {{ $t('Select Date/Time') }}
    
      section#merchant( :style='bg_company' )
        bf-wrapper
          base-card.name
            bf-flex
              img.logo.flex-item(:src='business.logo')

              bf-flex.title.flex-item.column
                h5
                  span {{ business.name }}
                  //- span.info-icon.actionable
                  //-   info-icon

                template(v-if='status')
                  .availability.available(v-if='status.available') {{ $t(status.title) }}
                  .availability.not-available(v-else) {{ $t(status.title) }}

                  span.subtitle(v-if="subtitle") {{ subtitle }}
              
              .fav-btn.actionable(
                v-if='account.id && account.id != business.user_id'
                :class='{ fav: favored }'
                @click='favor'
              )
                .icon
                  fav-icon
                .text {{ $t('Click to Toggle') }} 
                .vip(v-if='vip=="VIP"')
                  img(src='/ui/vip.svg')
            p( v-html='business.description' )


          base-card.contact(v-if='account.id')
            .address
              bf-flex
                span.icon
                  address-icon
                span.text {{ business.address }}
            .web
              bf-flex
                span.icon
                  web-icon
                a( :href='business.web' ).text {{ business.web }}
            .phone
              bf-flex
                span.icon
                  phone-icon
                span.text {{ business.phone }}
            .open
              bf-flex
                span
                  img(src='/ui/open-sign.svg' width='30')
                span.text {{ opening }} - {{ closing }}
          base-card.contact(v-else)
            .sign-up
              h5 {{ $t("Please Sign in/Sign up to view contact information and make reservation") }}
              p
                bf-button.wide.btn( @click.native='$router.push({ name: "sign-up-link", params: { bid: business.id } })')
                  template(v-slot:text) {{$t("Sign Up")}}

                bf-button.wide.btn( @click.native='$router.push({ name: "sign-in"})')
                  template(v-slot:text) {{$t("Sign In")}}

            
          //- base-card.description( v-if='business.description' )
          //-   p( v-html='business.description' )

      section#visits( :style='bg_visits' v-if='user && rsvs.length' )
        bf-wrapper
          bf-flex.heading
            h4 {{ $t("My Visits:")}}
            span {{ $t("Visited")}} {{ visits }} {{ $t("times")}}
          rsv-car(
            v-if='account.id'
            :user='user'
            :account='account'
            :merchant='merchant'
            @counted='visits = $event'
          )
        
      section#services.items( v-if='services.length' :style='bg_services' )
        bf-wrapper 
          bf-flex.centered.heading
            h4 {{ $t('Services Offered:') }}
            select.selcat(v-model='category_id' required)
              option(value='') {{ $t('Display All') }}
              option(v-for='c in categories' :value='c.id') {{ c.title }}

          srvs-car( 
            :user='user' 
            :account='account' 
            :merchant='business' 
            :srvs='services.filter( s => s.category_id == category_id || !category_id )' 
            @select='srv = $event; collection="services"'
          )

      section#products.items( v-if='products.length' :style='bg_services' )
        bf-wrapper 
          bf-flex.centered.heading
            h4 {{ $t('Products Offered:') }}:
            select.selcat(v-model='category_id' required)
              option(value='') {{ $t('Display All') }}
              option(v-for='c in categories' :value='c.id') {{ c.title }}

          srvs-car(
            collection='products'
            :user='user' 
            :account='account' 
            :merchant='business' 
            :srvs='products.filter( s => s.category_id == category_id || !category_id )' 
            @select='srv = $event; collection="products"'
          )

      section#catalogs.items( v-if='catalogs.length' :style='bg_services' )
        bf-wrapper 
          bf-flex.centered.heading
            h4 {{ $t('Catalog Items:') }}:
            select.selcat(v-model='category_id' required)
              option(value='') {{ $t('Display All') }}
              option(v-for='c in categories' :value='c.id') {{ c.title }}

          srvs-car( 
            collection='catalogs'
            :user='user' 
            :account='account' 
            :merchant='business' 
            :srvs='catalogs.filter( s => s.category_id == category_id || !category_id )'
            @select='srv = $event; collection="catalogs"'
          )
      
      section#coupons( v-if='discounts.available' :style='bg_coupons' )
        bf-wrapper
          bf-flex.centered.heading
            h4 {{ $t('Coupons Offered:') }}
          cps-car( :coupons='coupons' @show='coupon = $event' :merchant='merchant' :visited='!!visits' )

      section#recommend.centered-text( v-if='referrable' )
        bf-wrapper.heading
          bf-button.wide( @click.native='modal.refer = true' )
            template(v-slot:text) {{ $t('Refer Merchant to a Friend') }}
      
      base-modal( :show='modal.refer' )
        refer-form( :user='user' :account='account' :merchant='merchant' :business='business' @close='modal.refer = false' )
</template>

<script>
  import 'vue-cal/dist/vuecal.css'
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  import { Datetime } from 'vue-datetime'
  import SocialButton from '@/components/social-button'
  import BaseCard from '@/components/base-card'
  import QrCode from '@chenfengyuan/vue-qrcode'
  import ReserveDialog from '@/components/reserve-dialog'
  import RsvCar from '@/components/rsv-car'
  import CpsCar from '@/components/carousels/coupons'
  import VueCal from 'vue-cal'
  import SrvsCar from '@/components/carousels/services'
  import ReferForm from '@/components/forms/refer'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import SrvDtls from '@/components/modals/srv-dtls'
  import CpnDtls from '@/components/modals/coupon'

  export default {
    name: 'merchant.view',

    mixins: [View],

    components: {
      Datetime,
      SocialButton,
      BaseCard,
      QrCode,
      ReserveDialog,
      VueCal,
      RsvCar,
      SrvsCar,
      SrvDtls,
      ReferForm,
      BaseModal,
      ModalWrapper,
      CpsCar,
      CpnDtls
    },

    data() {
      return {
        settings: { lead: 0 },
        referrals: [],
        business: {},
        coupons: [],
        coupon: false,
        merchant: {}, // account doc belonging to the owner/merchant of the business
        services: [],
        products: [],
        catalogs: [],
        service_id: '',
        srv: false,
        collection: 'services',
        datetime: new Date().toISOString(),
        favorites: [],
        categories: [],
        category_id: '',
        key: 0,
        show: { reserve: false, service: false, cal: false },
        message: '',
        msg: '',
        visits: '(counting...)',
        modal: { refer: false },
        reservations: [],
        blacklisted: []
      }
    },
    
    firestore() {
      if ( this.user && this.user.uid ) return {
        blacklisted: db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', this.user.uid ),
        business: {
          ref: db.collection('businesses').doc( this.$route.params.id ),
          resolve: d => {
            db.collection( 'settings' ).doc( `${d.user_id}->settings` ).get().then( snap =>
              this.settings = snap.exists ? snap.data() : { lead: 0 }
            )
            this.$binding( 'merchant', db.collection('accounts').doc(d.user_id) )
            this.$binding( 'categories', db.collection('categories').where( 'account_id', '==', d.user_id ) )
            this.$binding( 'reservations', db.collection('reservations').where( 'business_id', '==', d.id ) )
            this.$binding( 'coupons', db.collection( 'coupons' ).where( 'uid', '==', d.user_id ).where( 'status', '==', 'active' ) )
            this.$binding( 'referrals', db.collection( 'referrals' ).where( 'by.id', '==', this.account.id ) )
          }
        },
        services: db.collection('services').where( 'business_id', '==', this.$route.params.id ).orderBy('title'),
        products: db.collection('products').where( 'business_id', '==', this.$route.params.id ).where( 'qty', '>', '0' ).orderBy( 'qty' ).orderBy('title'),
        catalogs: db.collection('catalogs').where( 'business_id', '==', this.$route.params.id ).orderBy('title')
      }
      else return {
        business: {
          ref: db.collection('businesses').doc( this.$route.params.id ),
          resolve: d => {
            db.collection( 'settings' ).doc( `${d.user_id}->settings` ).get().then( snap =>
              this.settings = snap.exists ? snap.data() : { lead: 0 }
            )
            this.$binding( 'merchant', db.collection('accounts').doc(d.user_id) )
            this.$binding( 'categories', db.collection('categories').where( 'account_id', '==', d.user_id ) )
            this.$binding( 'reservations', db.collection('reservations').where( 'business_id', '==', d.id ) )
            this.$binding( 'coupons', db.collection( 'coupons' ).where( 'uid', '==', d.user_id ).where( 'status', '==', 'active' ) )
            this.$binding( 'referrals', db.collection( 'referrals' ).where( 'by.id', '==', this.account.id ) )
          }
        },
        services: db.collection('services').where( 'business_id', '==', this.$route.params.id ).orderBy('title'),
        products: db.collection('products').where( 'business_id', '==', this.$route.params.id ).where( 'qty', '>', '0' ).orderBy( 'qty' ).orderBy( 'title' ),
        catalogs: db.collection('catalogs').where( 'business_id', '==', this.$route.params.id ).orderBy('title')
      }
    },

    computed: {
      blacked() {
        return this.blacklisted.map( b => b.business_id ).includes( this.business.id ) 
      },

      opening() {
        let d = new Date(this.business.cfg.opening)
        d.setMinutes( d.getMinutes() + new Date().getTimezoneOffset() )
        return d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      },

      closing() {
        let d = new Date(this.business.cfg.closing)
        d.setMinutes( d.getMinutes() + new Date().getTimezoneOffset() )
        return d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      },
      
      style() {
        if( this.merchant.merchant == 'value')
          return {
            backgroundImage: this.settings.background == 4 ? `url(${this.settings.uploaded})` : `url(/bgs/${this.settings.background}.jpg)`,
            backgroundColor: this.settings.color  
          }
      },

      bg_visits() {
        console.log(this.merchant.merchant)
        if ( this.merchant.merchant != 'value') return { background: `rgba( 132, 169, 241, 1)` }
        if ( !this.settings.customer ) return { background: `rgba( 220, 240, 220, 1)` }
        if ( !this.settings.customer.rgba ) return { background: `rgba( 240, 240, 240, 1)` }
        
        let { r, g, b, a } = this.settings.customer.rgba
        return { background: `rgba(${r}, ${g}, ${b}, ${a})` }

      },

      bg_services() {
        if ( this.merchant.merchant != 'value') return { background: `rgba( 245, 245, 245, 1)` }
        if ( !this.settings.services ) return { background: `rgba( 220, 220, 240, 1)` }
        if ( !this.settings.services.rgba ) return { background: `rgba( 220, 220, 240, 1)` }
        
        let { r, g, b, a } = this.settings.services.rgba
        return { background: `rgba(${r}, ${g}, ${b}, ${a})` }

      },

      bg_company() {
        if ( this.merchant.merchant != 'value') return { background: `rgba( 132, 169, 241, 1)` }
        if ( !this.settings.company ) return { background: `rgba( 240, 240, 240, 1)` }
        if ( !this.settings.company.rgba ) return { background: `rgba( 240, 240, 240, 1)` }
        
        let { r, g, b, a } = this.settings.company.rgba
        return { background: `rgba(${r}, ${g}, ${b}, ${a})` }

      },

      bg_coupons() {
        if ( this.merchant.merchant != 'value') return { background: `rgba( 245, 245, 245, 1)` }
        if ( !this.settings.coupons ) return { background: `rgba( 240, 240, 240, 1)` }
        if ( !this.settings.coupons.rgba ) return { background: `rgba( 240, 240, 240, 1)` }
        
        let { r, g, b, a } = this.settings.coupons.rgba
        return { background: `rgba(${r}, ${g}, ${b}, ${a})` }
      },

      ref() {
        return db.collection( 'settings' ).doc( `${this.business.user_id}->settings` )
      },

      rsvs() {
        return this.reservations.filter( r => r.account_id == this.account.id )
      }, 

      discounts() {
        this.merchant.rewards = this.merchant.rewards || []
        let rewards = Object.values( Object.values( this.merchant.rewards ) ).map( r => r.active ).filter( v => v )
        let available = this.coupons.length || rewards.length
        return { available }
      }, 

      vip(){
        return this.cust && this.cust.length ? this.cust[0].category : ''
      },

      referrable() {
        return true
        // return !this.referrals.find( r => r.for && r.for.biz && r.for.biz.id == this.$route.params.id )
      },

      favored() {
        return !!this.favorites.filter( favorite => favorite.business_id === this.business.id ).length
      },

      status() {
        if ( !this.business ) return false

        if ( !this.business.status ) return { available: true , title: 'Unknown' }

        switch( this.business.status.title ) {
          case 'Available'        : return { available: true , title: 'Available'}
          case 'Be back soon'     : return { available: false, title: 'Be back soon'}
          case 'Be back in'       : return { available: false, title: `Be back in ${this.business.status.duration} mins` }
          case 'Be back at'       : return { available: false, title: `Be back at ${this.business.status.time}` }
          case 'On vacation'      : return { available: false, title: `On vacation` }
          case 'On vacation till' : return { available: false, title: `On vacation till ${this.business.status.till}` }
          default                 : return { available: true , title: 'Available' }
        }
      },

      subtitle() {
        if(!this.business.status ) return false
        if( !this.business.status.subtitle ) return false
        return this.business.status.subtitle
      },

      owner() {
        return this.business.account_id == this.account.id
      }
    },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) {
          this.$binding( 'favorites', db.collection('favorites').where( 'account_id', '==', curr.id) )
          this.$binding( 'cust', db.collection( 'customers' ).where( 'business_id', '==', this.$route.params.id ).where( 'account_id', '==', curr.id ) )
        } 
      },

      user( curr, prev ) {
        if ( curr && curr.uid ) {
          this.$binding( 'blacklisted', db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', curr.uid ) )
        }
      }
    },

    methods: {
      notify(message) {
        this.message = message
      },

      favor() {
        if ( this.account.id == this.merchant.id ) return false
        if ( this.favored )
          db.collection('favorites').doc(
            this.favorites.find( favorite => favorite.business_id === this.business.id ).id
          ).delete()
        else
          db.collection('favorites').add({
            business_id: this.business.id,
            account_id: this.account.id
          })
      },

      reserve() {
        this.service_id = this.srv.id
        this.srv = false
        if ( !this.account.id && !this.user ) {
          this.message = this.$t('You must be signed in to make a reservation.  Redirecting now...')
          setTimeout( () => this.$router.push({ name: "sign-up-link", params: { bid: this.business.id } }), 2400 )
        }
        else
          if ( !this.service_id ) this.message = this.$t('Please select a service to make a reservation')
          else this.show.reserve = true
      },

      service_details(i=0) {
        this.srv = this.srvs[i]
        this.service_id = this.srv.id
        this.show.service = true
      }
    },

    mounted() {
      if ( this.account.id ) {
        this.$binding( 'favorites', db.collection('favorites').where( 'account_id', '==', this.account.id) )
        this.$binding( 'cust', db.collection( 'customers' ).where( 'business_id', '==', this.$route.params.id ).where( 'account_id', '==', this.account.id ) )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .sign-up
    p
      text-align center
      margin-top 24px
    a
      border 2px solid red
      color red
      padding 8px 16px
      font-weight 800
      border-radius 5px
    .bf-button.btn
      margin-left 20px
      margin-right 20px

  #default-layout
    background-size cover
    
  .unavailable
    height calc( 100vh - var(--height-merchant-nav) - 24px )
    text-align center
    align-items center
    background linear-gradient(white, white, #20458D)
    p
      padding 20px

  section
    padding 10px 0

  .msg
    padding 10px 20px 0px 20px
    border 1px solid lightgray
    background lightblue
    
  .bf-flex.centered.heading
    box-shadow var(--shadow-box)

  #merchant
    .bf-wrapper
      display grid
      grid-template-columns 2fr 1fr
      grid-gap 20px
      @media( max-width: 800px )
        grid-template-columns 1fr
      .name
        // display flex
        // justify-content space-between
        padding 20px
        p 
          margin-top 16px
        .bf-flex
          align-items stretch
          position relative
          height 100px
          .logo
            height 100%
          .title
            margin 0 16px
            align-items flex-start
            .availability
              margin-top auto
          h5
            display flex
            align-items center
          .availability
            margin-top 16px
            background rgb( 100 150 100 )
            color white
            padding 4px 16px
            border-radius 5px
            &.not-available
              background rgb( 160 160 160 )
          .subtitle
            color white
            padding 5px
            font-size .8em
            margin-top 5px
            background rgb(255 203 49)


      .contact
        padding 16px 24px

      .description
        padding 20px
        
    .fav-btn
      text-align center
      margin-left auto
      .icon
        font-size 2.21em
      .vip
        margin-top 25px
      &.fav .icon
        color red
      .text
        display none
        @media(min-width: 480px)
          display block

    .contact
      .bf-flex
        align-items center
        margin 4px 0
      .icon
        font-size 1.2em
        color rgb( 128 128 128 )
      .text
        margin-left 10px
        font-size .88em
      .web, .send-device
        .text
          color rgb(0 200 255)
    
    .description
      grid-column 1 / -1
      white-space pre-line

  #visits
    .heading
      background rgba( 255 255 255 0.85)
      padding 10px
      border-radius 5px
      align-items baseline
      margin-bottom 10px
      span
        margin-left 16px

  #coupons
    .heading
      background rgba( 255 255 255 0.85)
      padding 10px
      border-radius 5px
      text-align center
      justify-content flex-start
      margin-bottom 10px

  #merchant-cal-dialog
    #merchant-cal
      margin-top 24px

  #srv-dtls-dialog
    background rgba(40 40 40 .8)
    .rsv-btn
      padding 10px 10px
      text-align center
    .beta-note
      margin-top 12px
    
  #reserve-dialog
    .calendar
      margin-top 16px
      padding 8px

  .items
    > *
      margin-top 16px
      &:first-child
        margin-top 0
    .heading
      background rgba( 255 255 255 0.85)
      padding 10px
      border-radius 5px
      text-align center
      justify-content flex-start
      margin-bottom 10px
    .icon
      margin-left auto
      font-size 2.4em
    select
      width auto
      background white
      border 1px solid rgba( 0 0 0 .25 )
      border-radius 5px
      padding 6px 16px
      margin-left 24px
      z-index 0

  #recommend
    background rgba( 245 245 245 .8)

  .stamp
    color blue
    font-size 6em
    position absolute
    top 128px
    z-index 0
    left calc( 50vw - 170px )
    label
      background rgba( 255 255 255 .8)
      padding 10px
      border-radius 10px
      display block
      transform rotate(-36deg)
      font-weight bolder
      font-family 'arial black'
      letter-spacing 2px
      color rgba( 40 200 200 .2)  
</style>
